// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BecomeAPro-page-sQnVc {
  --red: #e8232b;
  --red-d: #c2151c;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #fff;
}

.BecomeAPro-wrap-_l03y {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px;
}

/* HERO */

.BecomeAPro-hero-kMrFn {
  background: radial-gradient(circle at 85% 12%, #fff0ef, transparent 45%),
    radial-gradient(circle at 8% 95%, #fff0ef, transparent 45%), #fff;
  padding: 64px 0 52px;
  text-align: center;
}

.BecomeAPro-eyebrow-hHqY6 {
  display: inline-block;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--red);
  margin-bottom: 16px;
}

.BecomeAPro-h1-hgjPM {
  font-size: clamp(34px, 6vw, 56px);
  line-height: 1.05;
  font-weight: 800;
  margin: 0 auto 18px;
  max-width: 760px;
}

.BecomeAPro-hl-BaVw2 {
  color: var(--red);
}

.BecomeAPro-sub-B3V6z {
  font-size: clamp(16px, 2.4vw, 20px);
  color: var(--muted);
  max-width: 600px;
  margin: 0 auto 30px;
  line-height: 1.55;
}

/* DOWNLOAD AREA */

.BecomeAPro-dl-kDOIo {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 36px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.BecomeAPro-badges-mjJMr {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 14px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
}

.BecomeAPro-badge-hpa83 {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 11px;
  background: #16a34a;
  color: #fff;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 14px;
  min-width: 180px;
  -webkit-transition: background 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: background 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: transform 0.16s, box-shadow 0.16s, background 0.16s;
  transition: transform 0.16s, box-shadow 0.16s, background 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
}

.BecomeAPro-badge-hpa83:hover {
  background: #0f7a37;
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
  -webkit-box-shadow: 0 14px 30px rgba(22, 163, 74, 0.3);
          box-shadow: 0 14px 30px rgba(22, 163, 74, 0.3);
}

.BecomeAPro-badgeLogo-iW5Sh {
  width: 26px;
  height: 26px;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
}

.BecomeAPro-badgeTxt-d7UiC {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  line-height: 1.1;
  text-align: left;
}

.BecomeAPro-badgeTxt-d7UiC small {
  font-size: 11px;
  opacity: 0.85;
}

.BecomeAPro-badgeTxt-d7UiC strong {
  font-size: 18px;
  font-weight: 700;
}

/* QR (desktop only) */

.BecomeAPro-qrCard-RJRSH {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 14px;
  padding: 14px 18px;
  border: 1px solid var(--line);
  border-radius: 16px;
  background: #fff;
  -webkit-box-shadow: 0 8px 24px rgba(15, 18, 20, 0.06);
          box-shadow: 0 8px 24px rgba(15, 18, 20, 0.06);
  font-size: 14px;
  font-weight: 600;
  color: var(--muted);
}

.BecomeAPro-qr-dfpZe {
  width: 96px;
  height: 96px;
  -webkit-box-flex: 0;
      -ms-flex: 0 0 auto;
          flex: 0 0 auto;
  border-radius: 8px;
}

.BecomeAPro-note-huSbn {
  margin-top: 20px;
  font-size: 14px;
  color: var(--muted);
}

/* SECTIONS */

.BecomeAPro-sec-hca7o {
  padding: 56px 0;
}

.BecomeAPro-h2-CIkAP {
  font-size: clamp(26px, 4vw, 38px);
  font-weight: 800;
  text-align: center;
  margin: 0 0 36px;
}

.BecomeAPro-grid-iRYx8 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.BecomeAPro-card-B_zgj {
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 26px 24px;
  background: #fff;
  -webkit-transition: border-color 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: border-color 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
  transition: transform 0.16s, box-shadow 0.16s, border-color 0.16s;
  transition: transform 0.16s, box-shadow 0.16s, border-color 0.16s, -webkit-transform 0.16s, -webkit-box-shadow 0.16s;
}

.BecomeAPro-card-B_zgj:hover {
  -webkit-transform: translateY(-3px);
      -ms-transform: translateY(-3px);
          transform: translateY(-3px);
  border-color: #f3c9cb;
  -webkit-box-shadow: 0 16px 36px rgba(15, 18, 20, 0.07);
          box-shadow: 0 16px 36px rgba(15, 18, 20, 0.07);
}

.BecomeAPro-cardIc-gLW9X {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: #fff0ef;
  color: var(--red);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin-bottom: 16px;
}

.BecomeAPro-cardIc-gLW9X svg {
  width: 26px;
  height: 26px;
}

.BecomeAPro-card-B_zgj h3 {
  font-size: 19px;
  font-weight: 800;
  margin: 0 0 8px;
}

.BecomeAPro-card-B_zgj p {
  font-size: 15px;
  line-height: 1.55;
  color: var(--muted);
  margin: 0;
}

/* STEPS */

.BecomeAPro-steps-bh3WI {
  background: #f7f8f9;
}

.BecomeAPro-stepRow-Sum79 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.BecomeAPro-step-ECTY8 {
  text-align: center;
  padding: 0 12px;
}

.BecomeAPro-stepNo-LpbPw {
  width: 46px;
  height: 46px;
  border-radius: 999px;
  background: var(--red);
  color: #fff;
  font-weight: 800;
  font-size: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  margin: 0 auto 16px;
}

.BecomeAPro-step-ECTY8 h3 {
  font-size: 18px;
  font-weight: 800;
  margin: 0 0 6px;
}

.BecomeAPro-step-ECTY8 p {
  font-size: 15px;
  color: var(--muted);
  margin: 0;
  line-height: 1.5;
}

/* FINAL CTA */

.BecomeAPro-finalCta-tmbUj {
  background: linear-gradient(135deg, var(--red), var(--red-d));
  color: #fff;
  text-align: center;
  padding: 60px 0;
}

.BecomeAPro-h2White-Q49zc {
  font-size: clamp(26px, 4vw, 38px);
  font-weight: 800;
  margin: 0 0 12px;
  color: #fff;
}

.BecomeAPro-subWhite-gpycI {
  font-size: 18px;
  opacity: 0.92;
  margin: 0 0 28px;
}

@media (max-width: 900px) {
  .BecomeAPro-grid-iRYx8 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 680px) {
  .BecomeAPro-hero-kMrFn {
    padding: 44px 0 40px;
  }
  .BecomeAPro-grid-iRYx8 {
    grid-template-columns: 1fr;
  }
  .BecomeAPro-stepRow-Sum79 {
    grid-template-columns: 1fr;
    gap: 28px;
  }
  .BecomeAPro-sec-hca7o {
    padding: 44px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/become-a-pro/BecomeAPro.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;;AACT;EACE;qEACmE;EACnE,oBAAoB;EACpB,kBAAkB;AACpB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AACA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AACA;EACE,iBAAiB;AACnB;;AACA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,kBAAkB;;AAClB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uFAA+D;EAA/D,+EAA+D;EAA/D,+DAA+D;EAA/D,kHAA+D;AACjE;;AACA;EACE,mBAAmB;EACnB,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,sDAA8C;UAA9C,8CAA8C;AAChD;;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAc;MAAd,kBAAc;UAAd,cAAc;AAChB;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AACA;EACE,eAAe;EACf,aAAa;AACf;;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,sBAAsB;;AACtB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,qDAA6C;UAA7C,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAc;MAAd,kBAAc;UAAd,cAAc;EACd,kBAAkB;AACpB;;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA,aAAa;;AACb;EACE,eAAe;AACjB;;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yFAAiE;EAAjE,iFAAiE;EAAjE,iEAAiE;EAAjE,oHAAiE;AACnE;;AACA;EACE,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,qBAAqB;EACrB,sDAA8C;UAA9C,8CAA8C;AAChD;;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAmB;AACrB;;AACA;EACE,WAAW;EACX,YAAY;AACd;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;;AAEA,UAAU;;AACV;EACE,mBAAmB;AACrB;;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,mBAAmB;AACrB;;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA,cAAc;;AACd;EACE,6DAA6D;EAC7D,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AACA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: #fff;\n}\n\n.wrap {\n  max-width: 1120px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n/* HERO */\n.hero {\n  background: radial-gradient(circle at 85% 12%, #fff0ef, transparent 45%),\n    radial-gradient(circle at 8% 95%, #fff0ef, transparent 45%), #fff;\n  padding: 64px 0 52px;\n  text-align: center;\n}\n.eyebrow {\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 800;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--red);\n  margin-bottom: 16px;\n}\n.h1 {\n  font-size: clamp(34px, 6vw, 56px);\n  line-height: 1.05;\n  font-weight: 800;\n  margin: 0 auto 18px;\n  max-width: 760px;\n}\n.hl {\n  color: var(--red);\n}\n.sub {\n  font-size: clamp(16px, 2.4vw, 20px);\n  color: var(--muted);\n  max-width: 600px;\n  margin: 0 auto 30px;\n  line-height: 1.55;\n}\n\n/* DOWNLOAD AREA */\n.dl {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 36px;\n  flex-wrap: wrap;\n}\n.badges {\n  display: flex;\n  gap: 14px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 11px;\n  background: #16a34a;\n  color: #fff;\n  text-decoration: none;\n  padding: 12px 20px;\n  border-radius: 14px;\n  min-width: 180px;\n  transition: transform 0.16s, box-shadow 0.16s, background 0.16s;\n}\n.badge:hover {\n  background: #0f7a37;\n  transform: translateY(-2px);\n  box-shadow: 0 14px 30px rgba(22, 163, 74, 0.3);\n}\n.badgeLogo {\n  width: 26px;\n  height: 26px;\n  flex: 0 0 auto;\n}\n.badgeTxt {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.1;\n  text-align: left;\n}\n.badgeTxt small {\n  font-size: 11px;\n  opacity: 0.85;\n}\n.badgeTxt strong {\n  font-size: 18px;\n  font-weight: 700;\n}\n\n/* QR (desktop only) */\n.qrCard {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px 18px;\n  border: 1px solid var(--line);\n  border-radius: 16px;\n  background: #fff;\n  box-shadow: 0 8px 24px rgba(15, 18, 20, 0.06);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--muted);\n}\n.qr {\n  width: 96px;\n  height: 96px;\n  flex: 0 0 auto;\n  border-radius: 8px;\n}\n.note {\n  margin-top: 20px;\n  font-size: 14px;\n  color: var(--muted);\n}\n\n/* SECTIONS */\n.sec {\n  padding: 56px 0;\n}\n.h2 {\n  font-size: clamp(26px, 4vw, 38px);\n  font-weight: 800;\n  text-align: center;\n  margin: 0 0 36px;\n}\n.grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n.card {\n  border: 1px solid var(--line);\n  border-radius: 20px;\n  padding: 26px 24px;\n  background: #fff;\n  transition: transform 0.16s, box-shadow 0.16s, border-color 0.16s;\n}\n.card:hover {\n  transform: translateY(-3px);\n  border-color: #f3c9cb;\n  box-shadow: 0 16px 36px rgba(15, 18, 20, 0.07);\n}\n.cardIc {\n  width: 48px;\n  height: 48px;\n  border-radius: 12px;\n  background: #fff0ef;\n  color: var(--red);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n}\n.cardIc svg {\n  width: 26px;\n  height: 26px;\n}\n.card h3 {\n  font-size: 19px;\n  font-weight: 800;\n  margin: 0 0 8px;\n}\n.card p {\n  font-size: 15px;\n  line-height: 1.55;\n  color: var(--muted);\n  margin: 0;\n}\n\n/* STEPS */\n.steps {\n  background: #f7f8f9;\n}\n.stepRow {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n.step {\n  text-align: center;\n  padding: 0 12px;\n}\n.stepNo {\n  width: 46px;\n  height: 46px;\n  border-radius: 999px;\n  background: var(--red);\n  color: #fff;\n  font-weight: 800;\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 16px;\n}\n.step h3 {\n  font-size: 18px;\n  font-weight: 800;\n  margin: 0 0 6px;\n}\n.step p {\n  font-size: 15px;\n  color: var(--muted);\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* FINAL CTA */\n.finalCta {\n  background: linear-gradient(135deg, var(--red), var(--red-d));\n  color: #fff;\n  text-align: center;\n  padding: 60px 0;\n}\n.h2White {\n  font-size: clamp(26px, 4vw, 38px);\n  font-weight: 800;\n  margin: 0 0 12px;\n  color: #fff;\n}\n.subWhite {\n  font-size: 18px;\n  opacity: 0.92;\n  margin: 0 0 28px;\n}\n\n@media (max-width: 900px) {\n  .grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (max-width: 680px) {\n  .hero {\n    padding: 44px 0 40px;\n  }\n  .grid {\n    grid-template-columns: 1fr;\n  }\n  .stepRow {\n    grid-template-columns: 1fr;\n    gap: 28px;\n  }\n  .sec {\n    padding: 44px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `BecomeAPro-page-sQnVc`,
	"wrap": `BecomeAPro-wrap-_l03y`,
	"hero": `BecomeAPro-hero-kMrFn`,
	"eyebrow": `BecomeAPro-eyebrow-hHqY6`,
	"h1": `BecomeAPro-h1-hgjPM`,
	"hl": `BecomeAPro-hl-BaVw2`,
	"sub": `BecomeAPro-sub-B3V6z`,
	"dl": `BecomeAPro-dl-kDOIo`,
	"badges": `BecomeAPro-badges-mjJMr`,
	"badge": `BecomeAPro-badge-hpa83`,
	"badgeLogo": `BecomeAPro-badgeLogo-iW5Sh`,
	"badgeTxt": `BecomeAPro-badgeTxt-d7UiC`,
	"qrCard": `BecomeAPro-qrCard-RJRSH`,
	"qr": `BecomeAPro-qr-dfpZe`,
	"note": `BecomeAPro-note-huSbn`,
	"sec": `BecomeAPro-sec-hca7o`,
	"h2": `BecomeAPro-h2-CIkAP`,
	"grid": `BecomeAPro-grid-iRYx8`,
	"card": `BecomeAPro-card-B_zgj`,
	"cardIc": `BecomeAPro-cardIc-gLW9X`,
	"steps": `BecomeAPro-steps-bh3WI`,
	"stepRow": `BecomeAPro-stepRow-Sum79`,
	"step": `BecomeAPro-step-ECTY8`,
	"stepNo": `BecomeAPro-stepNo-LpbPw`,
	"finalCta": `BecomeAPro-finalCta-tmbUj`,
	"h2White": `BecomeAPro-h2White-Q49zc`,
	"subWhite": `BecomeAPro-subWhite-gpycI`
};
module.exports = ___CSS_LOADER_EXPORT___;
